import React, { useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './App.css';
import BackButton from './BackButton';

function QuickStartGuideFrame() {
  /*
  QuickStartGuideFrame is the file-picker screen for uploading custom dealer
  frame images. It mirrors QuickStartGuidePlates but routes to
  /license-plate-confirm with assetType === 'frame', so LicencePlateConfirm
  knows to continue to /upload-plates (plate workflow) after the frame is sent.
  */
  const navigate = useNavigate();
  const location = useLocation();
  const fileInputRef = useRef(null);

  const [files] = useState(location.state?.files || []);

  const handleUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
      fileInputRef.current.click();
    }
  };

  const handleFilesSelected = (event) => {
    const fileList = event.target.files;
    const newFiles = fileList ? Array.from(fileList) : [];
    if (newFiles.length === 0) return;

    const mergedFiles = [
      ...files,
      ...newFiles.filter(
        nf => !files.some(f => f.name === nf.name && f.size === nf.size)
      ),
    ];

    navigate('/license-plate-confirm', {
      state: { files: mergedFiles, assetType: 'frame' },
    });
  };

  const handleSupportClick = () => navigate('/support');

  return (
    <div className="QuickStartGuidePlates">
      <h1 className="QuickStartGuidePlates-title">
        Upload your custom<br />dealer frame
      </h1>
      <div className="QuickStartGuidePlates-desc">
        Please use the button below to upload digital files of your custom dealer
        frame.
        <br /><br />
        These files should be sent in one of the following formats:
        <ol className="QuickStartGuidePlates-list">
          <li>
            Printable Vector Graphics (.eps format){' '}
            <span className="QuickStartGuidePlates-italic">*Preferred*</span>
          </li>
          <li>
            High-resolution Image File (.jpg, .png, etc.) – 2400x1200px resolution
            minimum.
          </li>
        </ol>
      </div>

      <button
        className="QuickStartGuidePlates-upload-btn"
        type="button"
        onClick={handleUploadClick}
      >
        <div className="QuickStartGuidePlates-upload-icon">⬆️</div>
        Upload Dealer Frame Images
      </button>

      <input
        ref={fileInputRef}
        type="file"
        accept=".eps,image/*"
        multiple
        style={{ display: 'none' }}
        onChange={handleFilesSelected}
      />

      <div className="QuickStartGuidePlates-support">
        Questions?{' '}
        <span className="support-link" onClick={handleSupportClick}>Click here</span>
        {' '}to reach out to our support team directly.
      </div>
      <BackButton />
    </div>
  );
}

export default QuickStartGuideFrame;
